import { useTranslation } from 'react-i18next';

enum ELang {
  en = 'en',
  es = 'es',
}

interface UseTranslationProps {
  ns?: string;
  config?: {
    lng?: keyof typeof ELang;
  };
}

export const useTrans = (props?: UseTranslationProps) => {
  const { t, i18n } = useTranslation(props?.ns, props?.config);
  return { t, i18n };
};
